import { render, staticRenderFns } from "./UserGroupDetailForm.vue?vue&type=template&id=41aa2d02&"
import script from "./UserGroupDetailForm.vue?vue&type=script&lang=js&"
export * from "./UserGroupDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupDetailForm.vue?vue&type=style&index=0&scope=local&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports